<sharry-header></sharry-header>
<div class="become-coordinator">
  <h1>{{ 'become-coordinator.title' | i18next }}</h1>
  <div class="become-coordinator__hero-wrapper">
    <sharry-hero
      component="trip"
      [backGroundImages]="heroImages">
    </sharry-hero>
  </div>
  <div class="become-coordinator__info">
    <div class="become-coordinator__info__text">
      <h3>{{ 'become-coordinator.text.title.one' | i18next }}</h3>
      <p [innerHTML]="'become-coordinator.text.desc.one' | i18next"></p>
    </div>
    <div class="become-coordinator__info__text">
      <h3>{{ 'become-coordinator.text.title.two' | i18next }}</h3>
      <p>
        <span>{{ 'become-coordinator.text.growing' | i18next }} </span>
        <a [routerLink]="'trip' | routeTranslate"
          ><strong>{{ 'become-coordinator.text.link' | i18next }}</strong></a
        ><span [innerHTML]="'become-coordinator.text.desc.two' | i18next"></span>
      </p>
    </div>
    <div class="become-coordinator__info__text">
      <h3>{{ 'become-coordinator.text.title.three' | i18next }}</h3>
      <p>
        {{ 'become-coordinator.text.desc.three' | i18next }}
      </p>
      <p [innerHTML]="'become-coordinator.text.desc.four' | i18next"></p>
    </div>
  </div>
  <div class="become-coordinator__opportunities">
    <h3>{{ 'become-coordinator.opportunities.title' | i18next }}</h3>
    <div class="become-coordinator__opportunities__grid">
      <div class="become-coordinator__opportunities__grid--item">
        <span>
          <sharry-icon
            svgClass="svg-icon"
            type="phosphor"
            name="calendar-check"></sharry-icon>
        </span>
        <h4>{{ 'become-coordinator.grid.title.one' | i18next }}</h4>
        <p>{{ 'become-coordinator.grid.desc.one' | i18next }}</p>
      </div>
      <div class="become-coordinator__opportunities__grid--item">
        <span>
          <sharry-icon
            svgClass="svg-icon"
            type="phosphor"
            name="users-four"></sharry-icon>
        </span>
        <h4>{{ 'become-coordinator.grid.title.two' | i18next }}</h4>
        <p>{{ 'become-coordinator.grid.desc.two' | i18next }}</p>
      </div>
      <div class="become-coordinator__opportunities__grid--item">
        <span>
          <sharry-icon
            svgClass="svg-icon"
            type="phosphor"
            name="handshake"></sharry-icon>
        </span>
        <h4>{{ 'become-coordinator.grid.title.three' | i18next }}</h4>
        <p>{{ 'become-coordinator.grid.desc.three' | i18next }}</p>
      </div>
      <div class="become-coordinator__opportunities__grid--item">
        <span>
          <sharry-icon
            svgClass="svg-icon"
            type="custom"
            name="worker"></sharry-icon>
        </span>
        <h4>{{ 'become-coordinator.grid.title.four' | i18next }}</h4>
        <p>{{ 'become-coordinator.grid.desc.four' | i18next }}</p>
      </div>
    </div>
    <div class="become-coordinator__opportunities__essentials">
      <img
        src="https://media.sharry.land/app/images/become-coordinator/image-cosa-ti-serve.webp"
        alt="what-you-need" />
      <div>
        <h4>{{ 'become-coordinator.grid.title.essentials' | i18next }}</h4>
        <ul>
          <li>
            <sharry-icon
              svgClass="svg-icon"
              type="phosphor"
              name="check"></sharry-icon>
            {{ 'become-coordinator.essentials.one' | i18next }}
          </li>
          <li>
            <sharry-icon
              svgClass="svg-icon"
              type="phosphor"
              name="check"></sharry-icon>
            {{ 'become-coordinator.essentials.two' | i18next }}
          </li>
          <li>
            <sharry-icon
              svgClass="svg-icon"
              type="phosphor"
              name="check"></sharry-icon>
            {{ 'become-coordinator.essentials.three' | i18next }}
          </li>
          <li>
            <sharry-icon
              svgClass="svg-icon"
              type="phosphor"
              name="check"></sharry-icon>
            {{ 'become-coordinator.essentials.four' | i18next }}
          </li>
          <li>
            <sharry-icon
              svgClass="svg-icon"
              type="phosphor"
              name="check"></sharry-icon>
            {{ 'become-coordinator.essentials.five' | i18next }}
          </li>
          <li>
            <sharry-icon
              svgClass="svg-icon"
              type="phosphor"
              name="check"></sharry-icon>
            {{ 'become-coordinator.essentials.six' | i18next }}
          </li>
          <li>
            <sharry-icon
              svgClass="svg-icon"
              type="phosphor"
              name="check"></sharry-icon>
            {{ 'become-coordinator.essentials.seven' | i18next }}
          </li>
        </ul>
      </div>
    </div>
  </div>
  <div class="become-coordinator__form">
    <h3>{{ 'become-coordinator.form.title.label' | i18next }}</h3>
    <p>
      {{ 'become-coordinator.form.can' | i18next }}
      <button
        class="bigger sharry-simple"
        (click)="onMailto('jobs@sharry.land')">
        {{ 'become-coordinator.form.send-email' | i18next }}
      </button>
      {{ 'become-coordinator.form.compile' | i18next }}
    </p>
    <form
      class="become-coordinator__form__wrapper"
      [formGroup]="applicationForm"
      (ngSubmit)="onSubmit()">
      <div class="become-coordinator__form__wrapper--box">
        <div>
          <label for="name">{{ 'contacts.form.name' | i18next }}*</label>
          <mat-form-field
            appearance="outline"
            class="white-backgrounded-field"
            id="name-field">
            <input
              matInput
              type="text"
              id="name"
              formControlName="name" />
            @if (applicationForm.get('name')?.dirty && applicationForm.get('name')?.errors?.required) {
              <mat-error>
                {{ 'form-validation.required' | i18next }}
              </mat-error>
            }
          </mat-form-field>
        </div>
        <div>
          <label for="surname">{{ 'contacts.form.surname' | i18next }}*</label>
          <mat-form-field
            appearance="outline"
            id="surname-field">
            <input
              matInput
              type="text"
              id="surname"
              formControlName="surname" />
            @if (applicationForm.get('surname')?.dirty && applicationForm.get('surname')?.errors?.required) {
              <mat-error>
                {{ 'form-validation.required' | i18next }}
              </mat-error>
            }
          </mat-form-field>
        </div>
      </div>
      <div class="become-coordinator__form__wrapper--box">
        <div>
          <label for="email">{{ 'contacts.form.email' | i18next }}*</label>
          <mat-form-field
            appearance="outline"
            id="email-field">
            <input
              matInput
              type="email"
              id="email"
              formControlName="email" />
            @if (applicationForm.get('email')?.dirty && applicationForm.get('email')?.errors?.required) {
              <mat-error>
                {{ 'form-validation.required' | i18next }}
              </mat-error>
            }
          </mat-form-field>
        </div>
        <div>
          <label for="phone">{{ 'become-coordinator.form.telephone' | i18next }}</label>
          <mat-form-field
            appearance="outline"
            id="phone-field">
            <input
              matInput
              type="text"
              id="phone"
              formControlName="phone" />
          </mat-form-field>
        </div>
      </div>
      <div class="become-coordinator__form__wrapper--box">
        <div>
          <label for="role">{{ 'contacts.form.role' | i18next }}*</label>
          <mat-form-field
            appearance="outline"
            id="role-field">
            <mat-select
              id="role"
              formControlName="role">
              @for (option of roleOptions; track option) {
                <mat-option [value]="option.key">{{ option.value }}</mat-option>
              }
              <mat-option [value]="coordinatorsRoleOthers">{{ 'coordinators.role.other' | i18next }}</mat-option>
            </mat-select>
            @if (applicationForm.get('role')?.dirty && applicationForm.get('role')?.errors?.required) {
              <mat-error>
                {{ 'form-validation.required' | i18next }}
              </mat-error>
            }
          </mat-form-field>
        </div>
        <div></div>
      </div>
      <label for="message">{{ 'become-coordinator.form.notes.label' | i18next }}</label>
      <mat-form-field
        appearance="outline"
        id="message-field">
        <textarea
          matInput
          id="message"
          rows="3"
          formControlName="message"
          [placeholder]="'become-coordinator.form.notes.placeholder' | i18next"></textarea>
        @if (applicationForm.get('message')?.dirty && applicationForm.get('message')?.errors?.required) {
          <mat-error>
            {{ 'form-validation.required' | i18next }}
          </mat-error>
        }
      </mat-form-field>
      <mat-checkbox
        id="privacy"
        formControlName="privacy"
        color="primary"
        >{{ 'contacts.form.checkbox' | i18next }}
        <a
          target="__blank"
          [routerLink]="'privacy' | routeTranslate">
          Privacy</a
        ></mat-checkbox
      >
      <button
        mat-flat-button
        class="sharry-big"
        color="primary"
        type="submit"
        [disabled]="applicationForm.invalid">
        {{ 'contacts.form.submit' | i18next }}
      </button>
    </form>
  </div>
</div>
<sharry-footer class="is-not-mobile"></sharry-footer>
